import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QaiDialogComponent } from '@qai/ui';

@Component({
  selector: 'app-simulation-detail-list-modal',
  standalone: true,
  imports: [CommonModule, QaiDialogComponent],
  templateUrl: './simulation-detail-list-modal.component.html',
  styleUrls: ['./simulation-detail-list-modal.component.scss'],
})
export class SimulationDetailListModalComponent {
  @Input() heading: string = '';
  @Input() subheading: string = '';

  @ViewChild('dialog') private dialogRef!: QaiDialogComponent;

  open(): void {
    this.dialogRef.showModal();
  }

  close(): void {
    this.dialogRef.close();
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}
